import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';
import { fade } from 'src/app/util/animations.util';
import { checkPasswords } from 'src/app/util/check-passwords.util';
import { strongPassword } from 'src/app/util/regex';
import { ChangeNameComponent } from '../change-name/change-name.component';


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: [
    '../change-name/change-name.component.css',
    './change-password.component.css'
  ],
  animations: [
    fade
  ]
})
export class ChangePasswordComponent implements OnInit {
  form: FormGroup;
  processing: boolean = false;
  constructor(
    private fb: FormBuilder,
    private user: UserService,
    private ref: MatDialogRef<ChangePasswordComponent>
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      currentPassword: ["", Validators.required],
      password: ["", [Validators.required, Validators.pattern(strongPassword)]],
      confirmPassword: ["", [Validators.required,  Validators.pattern(strongPassword)]]
    }, {
      validators: checkPasswords
    });
  }
  toggleVisiblePassword(inp: HTMLInputElement): void {
    inp.type = inp.type == "password" ? "text" : "password";
  }
  get pwdControl(): AbstractControl {
    return this.form.get('password');
  }
  get repwdControl(): AbstractControl {
    return this.form.get('confirmPassword');
  }
  get currentPassword(): AbstractControl {
    return this.form.get('currentPassword');
  }
  onChangePassword(): void {
    if (this.form.invalid) return this.form.markAllAsTouched();
    const value = this.form.value;
    if (value.oldPwd == value.password) {
      this.form.setErrors({
        same: true
      });
      return;
    }
    const payload = {
      old_password: value.currentPassword,
      new_password: value.password,
      confirm_new_password: value.confirmPassword
    }
    this.processing = true;
    this.user.changePassword(payload)
    .then(() => {
      this.ref.close(true);
    })
    .catch(() => {
      this.currentPassword.setErrors({
        incorrect: true
      });
      this.processing = false;
    });
  }
}
